<template>
  <div :styles="styles"
       class="service-order-card smd-panel"
       @click.prevent="onClick">
    <div class="service-order-card__grid">
      <service-left-icon :service-order="order" class="m-r-10" v-if="$isDesktop"/>
      <div>
        <div class="header m-b-10 flex-row--center-x">
          <service-left-icon :service-order="order" class="m-r-10" v-if="!$isDesktop"/>
          <div class="title">
            <text-string :label-id="header" class="service-order-card__title m-b-5"/>
            <text-string v-if="subHeaderTextProps" v-bind="subHeaderTextProps"/>
          </div>
        </div>
        <div v-if="!$isDesktop && showButton" class="buttons">
          <smd-btn section="4"
                   variant="red-enabled" @click.prevent="sendProofOfPayment">
            <text-string label-id="txt197"/>
          </smd-btn>
        </div>
        <div class="details">
          <div class="smd-form__row"
               :class="{'reset-m': $isDesktop}">
            <div class="smd-form__col">
              <text-string :label-id="dateLabel" class="m-b-5"/>
              <p :class="$isDesktop ? 'Body3' : 'Body1'"
                 v-if="order.daterequested">
                {{ order.daterequested | displayDateString }}
              </p>
              <p v-else>-</p>
            </div>
          </div>
          <div class="smd-form__row">
            <div class="smd-form__col">
              <text-string :label-id="secondDataLabel" class="m-b-5"/>
              <p :class="$isDesktop ? 'Body3' : 'Body1'"
                 v-if="secondDataValue">
                {{ secondDataValue }}
              </p>
              <p v-else>-</p>
            </div>
          </div>
        </div>
      </div>
      <div class="service-order-card__right">
        <div :class="{'service-order-card__status-icon': $isDesktop}">
          <status-icon :size="34" :show-status-text="$isDesktop" :item="order"/>
        </div>
        <smd-btn class="service-order-card__right-btn"
                 section="5"
                 variant="right-red-enabled"
                 v-show="$isDesktop && showButton"
                 @click.prevent.stop="sendProofOfPayment">
          <text-string label-id="txt197"/>
        </smd-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import {formatDate,} from '@/utils/dates';
  import StatusIcon from '@/components/common/status-icon';
  import ServiceLeftIcon from '@/components/services/service-left-icon';

  import {
    PARTNER_TYPES,
    DEFAULT_PHARMACIES,
    COUPON_FULFILLMENT_MODE,
    MEDICINE_SUBTITLES,
    STATUS_CODES,
  } from '@/reference/medicine';
  import Routes from "@/router/routes";

  export default {
    name: 'service-order-card',
    components: {
      StatusIcon,
      ServiceLeftIcon,
    },
    filters: {
      displayDateString(isoDate) {
        return formatDate(isoDate, 'h:mm A, MMM DD, YYYY');
      },
    },
    props: {
      order: {type: Object, required: true},
      clickable: {type: Boolean, default: true},
    },
    computed: {
      buttonLabel() {
        return {
          medicine: 'txt032',
          watsons: 'txt032',
          diagnostics: 'txt158',
        }[this.order.ordertype];
      },
      dateLabel() {
        return {
          medicine: this.$isDesktop ? 'txt073__desktop' : 'txt073',
          watsons: 'txt073',
          diagnostics: this.$isDesktop ? 'txt148__desktop' : 'txt148',
        }[this.order.ordertype];
      },
      dateValue() {
        return formatDate(this.order.daterequested, 'h:mm A, MMM DD, YYYY');
      },
      header() {
        return {
          medicine: this.$isDesktop ? 'txt070__desktop' : 'txt070',
          watsons: this.$isDesktop ? 'txt070__desktop' : 'txt070',
          diagnostics: this.$isDesktop ? 'txt031__desktop' : 'txt031',
        }[this.order.ordertype];
      },
      styles() {
        return {
          cursor: this.clickable ? 'pointer' : 'default',
        };
      },
      subHeaderTextProps() {
        if (!MEDICINE_SUBTITLES[this.order.partnercode]) return null;

        if (this.order.partnercode === DEFAULT_PHARMACIES.hipres) {
          return {
            labelId: 'txt045',
            props: {
              strings: [MEDICINE_SUBTITLES[this.order.partnercode]],
            },
          };
        }

        if (this.order.partnercode === DEFAULT_PHARMACIES.watsons) {
          return {
            labelId: 'txt036',
            props: {
              strings: [MEDICINE_SUBTITLES[this.order.fulfillmentmode]],
            },
          };
        }

        return {
          labelId: 'txt036',
          props: {
            strings: [MEDICINE_SUBTITLES[this.order.partnercode]],
          },
        };
      },
      secondDataLabel() {
        if (this.order.fulfillmentmode === COUPON_FULFILLMENT_MODE.PICKUP) {
          return this.$isDesktop ? 'txt355__desktop' : 'txt355';
        }

        return {
          medicine: this.$isDesktop ? 'txt033__desktop' : 'txt033',
          diagnostics: this.$isDesktop ? 'txt035__desktop' : 'txt035',
        }[this.order.ordertype];
      },
      secondDataValue() {
        if (this.order.ordertype === PARTNER_TYPES.medicine) {
          if (this.order.fulfillmentmode === COUPON_FULFILLMENT_MODE.PICKUP) {
            return this.order.branchName;
          } else {
            return this.order.addressString;
          }
        } else {
          return [
            this.order.firstname,
            this.order.middlename,
            this.order.lastname,
          ]
            .filter((name) => !!name)
            .join(' ');
        }
      },
      showButton() {
        // return this.order.status === STATUS_CODES.FULFILLED;
        switch (this.order.status) {
          // case STATUS_CODES.FULFILLED:
          case STATUS_CODES.AWAITING_PAYMENT:
            return true
        }

        return false;
      },
    },
    methods: {
      onClick() {
        this.$emit('click');
      },
      sendProofOfPayment() {
        this.$router.push({
          name: Routes.ORDER_CHAT_ROUTE,
          params: {
            [Routes.ORDER_CHAT_ROUTE_PARAM]: this.order.orderid,
          },
        });
      }
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .service-order-card {
    @include responsive(desktop) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 160px;
      padding: space(m-base);
    }
    background: color(white);
    position: relative;

    .header {
      .title {
        flex: 1;
      }
    }

    .details {
      @include responsive(desktop) {
        display: grid;
        grid-template-columns: 200px 1fr;
      }
    }

    .service-left-icon {
      @include responsive(desktop) {
        font-size: 120px !important;
      }
    }

    .buttons {
      @extend %layout--flex-row-center-xy;
      margin: space(l) 0 space(l) space(xxl);
    }
  }

  .service-order-card__title {
    > span {
      color: color(gray-900) !important;
    }
  }

  .service-order-card__grid {
    @include make-grid-cols(1fr 50px);
    @include responsive(desktop) {
      grid-template-columns: 120px 3fr 235px;
      grid-column-gap: space(m-base);
      align-items: center;
    }
  }

  .service-order-card__right {
    @extend %layout--flex-col;
    align-items: flex-end;
    @include responsive(desktop) {
      margin-top: -30px;
    }
  }

  .service-order-card__right-btn {
    position: absolute;
    bottom: 0 !important;
    right: 0 !important;
    max-width: 235px;
    min-height: 68px;
  }

  .service-order-card__status-icon {
    @extend %layout--flex-center-xy;
    position: absolute;
    top: 0;
    right: 0;
    height: 90px;
    width: 235px;

    .status-icon {
      margin-right: 5px !important;
    }
  }
</style>
